import { groupBy, orderBy } from "lodash";
import { Item__Atividades, Item__UnidadeMedida, ItemPropriedades } from "../../../../../../../../../services/atividades/GET";
import { dummy_tipos_uso, extrairUnidade } from "../../../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { Item__EquipeCliente } from "../../../../../../../../../services/Equipe/GET";
import { normarlizarEmKg, obterCodInsumoDashboard, obterNomeMediaLocal } from "../../../../insumosPrecisao/meta";


export function obterInsumoPorTalhao(todas_atividades_ativas: Item__Atividades[], cod_insumo: number, data_propriedades: ItemPropriedades[]) {

    //@ts-ignore
    const talhoes = (data_propriedades ?? []).map(i => i.talhao)?.flat();

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i,
            andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo,
                            nome_medida_filtro: obterNomeMediaLocal(k.cod_medida).nome_filtro,
                            tipo_fisico_medida: obterNomeMediaLocal(k.cod_medida).tipo_fisico,
                            cod_insumo: obterCodInsumoDashboard(k)
                        }
                    }).filter(insumo => insumo.tipo_fisico_medida === "Sementes")
                }
            })
        }
    }).filter(i => i.delete_time === null);

    const apenas_insumo_selecionado = incluir_tipo_atv.map(atividade => {
        return {
            ...atividade,
            andamentos: atividade.andamentos.map(andamento => {
                return { ...andamento, insumos: andamento.insumos.filter(insumo => insumo.cod_insumo === cod_insumo) }
            }).filter(andamento => andamento.insumos.length > 0)
        };
    }).filter(atividade => atividade.andamentos.length > 0);

    const agrupar_por_talhao = groupBy(apenas_insumo_selecionado, "cod_talhao");

    const atvs_agrupadas_por_talhao = Object.entries(agrupar_por_talhao).map(([cod_talhao, lista_atividades]) => {
        const atvs_planejadas = lista_atividades.filter(i => i.cod_tipo === 1);
        const atvs_executadas = lista_atividades.filter(i => i.cod_tipo === 2);

        const quantidade_planejada = atvs_planejadas.reduce((acc_atv, atv) => {
            return acc_atv + (atv.andamentos ?? []).reduce((acc_and, and) => {
                return acc_and + (and.insumos ?? []).reduce((acc_ins, ins) => acc_ins + (Number(ins.quantidade) || 0), 0);
            }, 0);
        }, 0);

        const quantidade_executada = atvs_executadas.reduce((acc_atv, atv) => {
            return acc_atv + (atv.andamentos ?? []).reduce((acc_and, and) => {
                return acc_and + (and.insumos ?? []).reduce((acc_ins, ins) => acc_ins + (Number(ins.quantidade) || 0), 0);
            }, 0);
        }, 0);

        let precisao = 0;
        let porcentagem = 0;

        if (quantidade_planejada > 0) {
            const porcentagem_realizada = (quantidade_executada / quantidade_planejada) * 100;
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;
            porcentagem = porcentagem_realizada;
        } else if (quantidade_executada > 0) {
            precisao = 0;
            porcentagem = 0;
        }

        return {
            cod_talhao: Number(cod_talhao),
            nome_talhao: talhoes.find(t => t.cod === Number(cod_talhao))?.nome,
            nome_propriedade: data_propriedades.find(t => t.cod === Number(lista_atividades?.[0]?.cod_propriedade))?.nome,
            atvs_planejadas,
            atvs_executadas,
            quantidade_planejada: Number(quantidade_planejada.toFixed(2)),
            quantidade_executada: Number(quantidade_executada.toFixed(2)),
            precisao: Number(precisao.toFixed(2)),
            porcentagem: Number(porcentagem.toFixed(2))
        }
    })

    return orderBy(atvs_agrupadas_por_talhao, ['nome_propriedade', 'quantidade_executada', 'quantidade_planejada'], ['asc', 'desc', 'desc']) ?? [];
};





export function estruturaListarInsumos(
    atividades_com_o_insumo: any[],
    data_unidades_medida: any[],
    // data_unidades_medida: Item__UnidadeMedida[],
    data_equipe_cliente: Item__EquipeCliente[],
    todas_atividades_ativas: Item__Atividades[],
) {

    function obterNomeAtvPlanejada(cod_atividade_planejada: number) {
        const atv = todas_atividades_ativas.find(i => i.cod === cod_atividade_planejada);
        return atv?.descricao;
    }

    const add_info_atv = atividades_com_o_insumo.map(i => {
        return {
            ...i,
            andamentos: i.andamentos.map(j => {
                return {
                    ...j,
                    insumos: j.insumos.map(k => {
                        function obterNomeOperador(cod_usuario: number | null): string | null {
                            const operador = (data_equipe_cliente ?? []).find(eq => eq?.cod_func === cod_usuario);
                            return operador ? operador.usuario_nome ?? null : null;
                        }
                        return {
                            ...k,
                            area: j.area,
                            cod_tipo_atividade: i.cod_tipo,
                            nome_atividade: i.cod_tipo === 1 ? i.descricao : obterNomeAtvPlanejada(i.cod_atividade),
                            operadores_atv: obterNomeOperador(j.cod_usuario),
                            data_atv_inicio: i.data_inicio,
                            data_atv_fim: i.data_fim,
                            tipo_uso_nome: dummy_tipos_uso.find(t => t.cod === k.cod_tipo)?.nome,
                            nome_medida: data_unidades_medida.find(t => t.cod === k.cod_medida)?.nome,
                        }
                    })
                }
            })
        }
    });

    //@ts-ignore
    const apenas_insumos = add_info_atv.map(i => i.andamentos.map(j => j.insumos)).flat(2);

    return orderBy(apenas_insumos, ['data_atv_inicio'], ['asc']) ?? [];
}
